import { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Option } from "@fluentui/react-components";
import { DirectionalHint, TooltipHost } from "@fluentui/react";
import "./InMeetingNew1Tab.css";
import { InMeetingService } from "../../services/inMeeting.service";
import config from "../lib/config";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import { toast } from "react-toastify";

interface IInputData {
  MeetingDetails: {
    meetingId: string | undefined;
    eId: string | undefined;
    email: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
  };
}

export default function InMeetingNew1Tab(props: IInputData) {
  const [careerLevelSelected, setCareerLevel] = useState("");
  const [selectedProgPoints, setSelectedProgPoints] = useState("");
  const [selectedMonthAtLeval, setSelectedMonthAtLeval] = useState("");
  const [aiGenComment, setAiGenComment] = useState(false);
  const [skillReqText, setSkillReq] = useState("");
  const [skillReqErr, setSkillReqErr] = useState(false);
  const [cid, setCid] = useState("");
  const [overallText, setOverallText] = useState("");
  const [overallTextErr, setOverallTextErr] = useState(false);
  const [overallTextQ, setOverallTextQ] = useState("");
  const [overallTextOptional, setOverallTextOptional] = useState("");
  const [overallTextQErr, setOverallTextQErr] = useState(false);
  const [selectedOption1, setSelectedOption1] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [selectedOption3, setSelectedOption3] = useState("");
  const [selectedOption4, setSelectedOption4] = useState("");
  const [selectedPrimary, setSelectedPrimary] = useState("");
  const [overallRating, setOverallRating] = useState("");
  const [intType, setIntType] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [eiNotes, setEiNotes] = useState("");
  const [showCndDetails, setShowCndDetails] = useState(false);
  // const [socket, setSocket] :any = useState(null);
  const [allowSubmit, setAllowSubmit]: any = useState(false);
  const [submitSuccess, setSubmitSuccess]: any = useState(false);
  const [showNew, setShowNew]: any = useState(false);
  const [showReview, setShowReview]: any = useState(false);
  const [showGenFeedback, setShowGenFeedback]: any = useState(false);

  const { themeString } = useTeamsUserCredential({
    initiateLoginEndpoint: config.initiateLoginEndpoint!,
    clientId: config.clientId!,
  });
  const [currentTheme, setThemeState] = useState("light");
  const [isLightTheme, setLightTheme] = useState(true);
  const [submitMsg, setSubmitMsg] = useState<string>("");
  const [colapseCndDetails, setColapseCndDetails]: any = useState(false);
  const [colapseEINotes, setColapseEINotes]: any = useState(false);
  const [readMore, setReadMore]: any = useState(false);
  const [colapseSkillsForm, setColapseSkillsForm]: any = useState(false);
  const [colapseOverallForm, setColapseOverallForm]: any = useState(false);
  const [genText, setGenText]: any = useState("Generate Feedback Summary");
  const [cndDeatils, setCndDetails]: any = useState();
  const [invalidCid, setInvalidCid]: any = useState("");
  const [showLoader, setShowLoader]: any = useState(false);
  const [showProceedFeed, setShowProceedFeed]: any = useState(true);
  const [showErrorEi, setShowErrorEi]: any = useState(false);
  const [clickedGenFeed, setClickedGenFeed]: any = useState(false);
  const [feedbackRating, setFeedbackRating]: any = useState(0);
  const [ratingSubmitted, setRatingSubmitted]: any = useState(false);
  const [additionalFeedback, setAdditionalFeedback]: any = useState("");
  const [genFeedbackUsed, setGenFeedbackUsed]: any = useState(false);
  const [genFeedbackModUsed, setGenFeedbackModUsed]: any = useState(false);
  const [ownFeedbackUsed, setOwnFeedbackUsed]: any = useState(false);
  const [ownFeedbackModUsed, setOwnFeedbackModUsed]: any = useState(false);
  const [userFeedback, setUserFeedback]: any = useState("");
  const [genFeedback, setGenFeedback]: any = useState("");
  const [feedbackType, setFeedbackType]: any = useState("");
  const [error, setError]: any = useState("");
  const [showNoCnd, setShowNoCnd]: any = useState("");
  const [showRatingTab, setShowRatingTab]: any = useState(false);
  const [file, setFile] = useState<File | null>(null);
  // const [uploadStatus, setUploadStatus] = useState('');
  const [base64File, setBase64File] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    sessionStorage.getItem("EI") == undefined ||
    sessionStorage.getItem("EI") == null
      ? props.MeetingDetails.eId != undefined
        ? sessionStorage.setItem("EI", props.MeetingDetails.eId)
        : sessionStorage.setItem("EI", "13254884")
      : null;
    sessionStorage.getItem("IntStartDate") == undefined ||
    sessionStorage.getItem("IntStartDate") == null ||
    sessionStorage.getItem("IntStartDate") == ""
      ? sessionStorage.setItem("IntStartDate", "2024-01-04T00:00:00+00:00")
      : null;
    sessionStorage.getItem("IntEndDate") == undefined ||
    sessionStorage.getItem("IntEndDate") == null ||
    sessionStorage.getItem("IntEndDate") == ""
      ? sessionStorage.setItem("IntEndDate", "2025-05-26T00:00:00+00:00")
      : null;
    sessionStorage.setItem("tempToken", "");
    if (
      props.MeetingDetails != undefined &&
      props.MeetingDetails.meetingId != undefined &&
      props.MeetingDetails.meetingId != null &&
      props.MeetingDetails.meetingId != ""
    ) {
      setShowNew(false);
      fetchCandidateDetails();
    } else {
      setShowNew(false);
      setError("Kindly access the Interview invitation to submit feedback");
    }
  }, [props.MeetingDetails]);

  useEffect(() => {
    if (themeString == "dark") {
      setThemeState("dark");
      setLightTheme(false);
    } else if (themeString == "contrast") {
      setThemeState("contrast");
      setLightTheme(false);
    } else {
      setThemeState("light");
      setLightTheme(true);
    }
    // sessionStorage.getItem("EI") == undefined || sessionStorage.getItem("EI") == null || sessionStorage.getItem("EI") == ""? sessionStorage.setItem("EI","13254884") : null;
    // sessionStorage.getItem("IntStartDate") == undefined || sessionStorage.getItem("IntStartDate") == null || sessionStorage.getItem("IntStartDate") == ""? sessionStorage.setItem("IntStartDate", "2024-01-04T00:00:00+00:00") : null;
    // sessionStorage.getItem("IntEndDate") == undefined || sessionStorage.getItem("IntEndDate") == null || sessionStorage.getItem("IntEndDate") == ""? sessionStorage.setItem("IntEndDate", "2025-05-26T00:00:00+00:00") : null;
    // sessionStorage.setItem("tempToken","")
    // sessionStorage.getItem("Cid") == undefined || sessionStorage.getItem("Cid") == null || sessionStorage.getItem("Cid") == ""? sessionStorage.setItem("Cid", "C14601109") : null;
  }, [themeString]);

  useEffect(() => {
    checkFeedbackValidations();
  }, [
    overallRating,
    overallText,
    skillReqText,
    selectedPrimary,
    careerLevelSelected,
    selectedMonthAtLeval,
    selectedProgPoints,
    selectedOption1,
    selectedOption2,
    selectedOption3,
    selectedOption4,
    overallTextQ,
  ]);

  useEffect(() => {
    feedbackTypeCheck();
  }, [
    genFeedbackModUsed,
    genFeedbackUsed,
    ownFeedbackModUsed,
    ownFeedbackUsed,
  ]);

  useEffect(() => {
    checkQuestionsYesNo();
  }, [selectedOption1, selectedOption2, selectedOption3]);

  const recommendedMonths = [
    { id: "none", value: "Not applicable" },
    { id: "0", value: "0 months" },
    { id: "6", value: "6 months" },
    { id: "12", value: "12 months" },
    { id: "18", value: "18 months" },
    { id: "24", value: "24 months" },
    { id: "30", value: "30 months" },
    { id: "36", value: "36 or more months" },
  ];

  const progressionPoints = [
    {
      level: "6",
      array: [
        { id: "none", value: "Not Applicable" },
        { id: "A", value: "A - First Year" },
        { id: "B", value: "B - Second Year" },
        { id: "C", value: "C - Third Year" },
        { id: "D", value: "D - Fourth Year" },
        { id: "E", value: "E - Fifth Year" },
      ],
    },
    {
      level: "7",
      array: [
        { id: "none", value: "Not Applicable" },
        { id: "A", value: "A - First Year" },
        { id: "B", value: "B - Second Year" },
        { id: "C", value: "C - Third Year" },
        { id: "D", value: "D - Fourth Year (Consulting Only)" },
        { id: "E", value: "E - Fifth Year" },
      ],
    },
    {
      level: "9",
      array: [
        { id: "none", value: "Not Applicable" },
        { id: "A", value: "A - First Year" },
        { id: "B", value: "B - Second Year" },
        { id: "C", value: "C - Third Year" },
        { id: "D", value: "D - Fourth Year (Strategy Only)" },
      ],
    },
    {
      level: "10",
      array: [
        { id: "none", value: "Not Applicable" },
        { id: "A", value: "A - First Year (Consulting Only)" },
        { id: "B", value: "B - Second Year (Consulting Only)" },
      ],
    },
    {
      level: "11",
      array: [
        { id: "none", value: "Not Applicable" },
        { id: "A", value: "A - First Year (Consulting Only)" },
      ],
    },
  ];

  const careerLevel = [
    {
      id: "Keep the same as requisition",
      value: "Keep the same as requisition",
    },
    { id: "Do Not Recommend", value: "Do Not Recommend" },
    { id: "13", value: "13 - New Associate/Assistant" },
    { id: "12", value: "12 - Associate" },
    { id: "11", value: "11 - Analyst" },
    { id: "10", value: "10 - Senior Analyst" },
    { id: "9", value: "9 - Consultant/Specialist/Team Lead" },
    { id: "8", value: "8 - Associate Manager" },
    { id: "7", value: "7 - Manager" },
    { id: "6", value: "6 - Senior Manager" },
    { id: "5", value: "5 - Associate Director" },
    { id: "4", value: "4 - Managing Director" },
    { id: "3", value: "3 - Managing Director" },
    { id: "2", value: "2 - Managing Director" },
    { id: "1", value: "1 - Senior Managing Director" },
  ];
  const overallRatingArray = [
    { id: "Highly_Recommend", value: "3 - Highly Recommend" },
    {
      id: "Recommend_with_Reservations",
      value: "2 - Recommend with Reservations",
    },
    {
      id: "Not_Suitable_for_this_Position",
      value: "1 - Not Suitable for this Position",
    },
  ];
  // const monthslevel = [ "Not Applicable", "0 months", "6 months", "12 months", "18 months", "24 months", "30 months", "36 months", "42 months", "48 months"]

  // const handleMouseEnter = (grading:any) => {
  //     setHover(grading);
  // };
  // const handleMouseLeave = () => {
  //     setHover(null);
  // };

  const tooltipContent = (
    <div>
      <strong>Guidelines for Capturing Interview Feedback</strong>
      <p>
        To ensure a fair and structured hiring process, please follow these
        guidelines when providing interview feedback:
      </p>
      <ul>
        <li>
          <strong>Be Objective & Specific:</strong> Focus on skills, experience,
          and responses. Avoid personal bias.
        </li>
        <li>
          <strong>Use a Structured Format:</strong> Cover key areas: technical
          skills, problem-solving, communication, and culture fit.
        </li>
        <li>
          <strong>Provide Clear Ratings:</strong> Use predefined rating scales
          to ensure consistency.
        </li>
        <li>
          <strong>Support with Examples:</strong> Highlight strong or weak
          responses to justify your assessment.
        </li>
        <li>
          <strong>Keep it Concise & Actionable:</strong> Ensure feedback is
          clear and useful for decision-making.
        </li>
        <li>
          <strong>Submit Feedback on Time:</strong> Prompt feedback speeds up
          hiring and improves candidate experience.
        </li>
      </ul>
    </div>
  );

  const onMonthLevelChanged = function (_e: any, data: any) {
    setSelectedMonthAtLeval(data.optionValue);
  };

  const onCareerLevelChanged = function (_e: any, value: any) {
    if (value) {
      setCareerLevel(value.optionValue);
      setSelectedProgPoints("");
      setSelectedMonthAtLeval("");
    }
  };

  const onOverallRatingChanged = function (_e: any, value: any) {
    if (value) setOverallRating(value.optionValue);
  };

  // async function getMeetingDetails() {
  //         await msalInstance.initialize().then(async ()=>{
  //             if (msalInstance.getAllAccounts()?.length === 0) {
  //                 await msalInstance.loginPopup({ scopes: ["User.Read", "OnlineMeetings.Read"] })
  //             }
  //             if(msalInstance.getAllAccounts()?.length > 0){
  //                 var request = {
  //                     scopes: ["User.Read", "OnlineMeetings.Read"],
  //                     account: msalInstance.getAllAccounts()[0]
  //                 };
  //                 await msalInstance.acquireTokenSilent(request).then(async (token:any)=>{
  //                     console.log("acquireTokenSilent Access Token", token.accessToken);
  //                     // const decodedJoinId = atob(props.MeetingDetails?props.MeetingDetails:"");
  //                     // const filterJoinId = encodeURIComponent(decodedJoinId);
  //                     const response = await fetch(
  //                     // `https://graph.microsoft.com/v1.0/me/onlineMeetings/?$filter=joinMeetingIdSettings/joinMeetingId eq ${props.MeetingDetails}`,
  //                     // `https://graph.microsoft.com/v1.0/me/onlineMeetings/?$filter=joinMeetingIdSettings/joinMeetingId eq 19:meeting_MjVjOTdlM2ItOTBiYy00Y2NjLTg4ZmMtODgzNjIyNzM0YWM2@thread.v2`,
  //                     // `https://graph.microsoft.com/v1.0/me/onlineMeetings?$filter=JoinWebUrl eq https://teams.microsoft.com/l/meetup-join/19:meeting_MjVjOTdlM2ItOTBiYy00Y2NjLTg4ZmMtODgzNjIyNzM0YWM2@thread.v2/0`,
  //                     // {
  //                     //     headers: {
  //                     //     Authorization: `Bearer ${token.accessToken}`,
  //                     //     },
  //                     // }
  //                     `https://graph.microsoft.com/v1.0/chats/`+props.MeetingDetails,
  //                     {
  //                         method : "GET",
  //                         headers: {
  //                             Authorization: `Bearer ${token.accessToken}`,
  //                             "Content-Type": "application/json"
  //                         }
  //                     }
  //                     );
  //                     const meeting = await response.json();
  //                     if(meeting?.onlineMeetingInfo?.joinWebUrl)
  //                     {
  //                         console.log("Meeting Details", meeting?.onlineMeetingInfo?.joinWebUrl);
  //                         const MeetingInfo = await fetch(
  //                             `https://graph.microsoft.com/v1.0/me/onlineMeetings?$filter=JoinWebUrl eq '`+meeting?.onlineMeetingInfo?.joinWebUrl +`'`,
  //                             {
  //                                 method : "GET",
  //                                 headers: {
  //                                     Authorization: `Bearer ${token.accessToken}`,
  //                                     "Content-Type": "application/json"
  //                                 }
  //                             }
  //                         )
  //                         const meetingInfo = await MeetingInfo.json();
  //                         console.log("Meeting Info", meetingInfo);
  //                     }

  //                 })
  //             }
  //         })
  // }

  function reset() {
    setCareerLevel("");
    setSelectedProgPoints("");
    setSelectedMonthAtLeval("");
    setSkillReq("");
    setCid("");
    setOverallText("");
    setOverallTextQ("");
    setSelectedOption1("");
    setSelectedOption2("");
    setSelectedOption3("");
    setSelectedOption4("");
    setSelectedPrimary("");
    setOverallRating("");
    setIntType("");
    setShowForm(false);
    setEiNotes("");
    setShowCndDetails(false);
    setAllowSubmit(false);
    setSubmitSuccess(false);
    // setShowNew(true);
    setShowNew(false);
    setShowReview(false);
    setShowGenFeedback(false);
    setSubmitMsg("");
    setShowRatingTab(false);
    setColapseCndDetails(false);
    setColapseEINotes(false);
    setReadMore(false);
    setColapseSkillsForm(false);
    setColapseOverallForm(false);
    setGenText("Generate Feedback Summary");
    setCndDetails(null);
    setInvalidCid("");
    setShowLoader(false);
    setShowProceedFeed(true);
    setShowErrorEi(false);
    setClickedGenFeed(false);
    setSkillReqErr(false);
    setOverallTextErr(false);
    setOverallTextQErr(false);
    setAiGenComment(false);
  }

  function fetchCandidateDetails() {
    const timezoneOffset =
      new Date().toString().match(/\(([^)]+)\)/)?.[1] || "Unknown Timezone";
    let inMeetingService = new InMeetingService();
    let requestPayload = {
      EI: {
        EmployeeID: sessionStorage.getItem("EI") || props.MeetingDetails.eId,
        EnterpriseID: props.MeetingDetails.email,
      },
      Interview: {
        StartDateTime:
          props.MeetingDetails.startTime ||
          sessionStorage.getItem("IntStartDate"),
        EndDateTime:
          props.MeetingDetails.endTime || sessionStorage.getItem("IntEndDate"),
        currentTimezone: timezoneOffset,
      },
    };

    setShowLoader(true);
    inMeetingService
      .fetchCandidateDetails(requestPayload)
      .then((result: any) => {
        setShowLoader(false);
        const showCandidate = (data: any) => {
          setCndDetails(data);
          setShowCndDetails(true);
          setShowReview(false);
          setShowForm(false);
          setShowNew(false);
          setSubmitSuccess(false);
          setShowGenFeedback(false);
          setShowNoCnd(false);
        };
        const showError = (msg: string) => {
          setShowCndDetails(false);
          setShowNoCnd(true);
          setInvalidCid(msg);
        };
        if (result?.message) {
          switch (result.message) {
            case "matching Candidate Not found.":
              return showError("CID not found, try again with valid CID!");
            case "No results found.":
              return showError(
                "Feedback is already submitted for this candidate."
              );
            case "Interview scheduling details not found for the given candidate":
              return showError(
                "Interview scheduling details not found for the given candidate"
              );
            default:
              return showCandidate(result);
          }
        }
        if (
          result.job_Requisition_Primary_Location !== "United Kingdom" &&
          result.job_Requisition_Primary_Location !== "Ireland"
        ) {
          return showError(
            "Feedback submission via Feedback app is currently enabled only for UK and Ireland"
          );
        }

        if (result.interviewType !== "Skills Interview") {
          return showError(
            "Feedback via Feedback App is only available for Skill interview"
          );
        }

        return showCandidate(result);
      })

      .catch((err: any) => {
        setShowLoader(false);
        setShowNoCnd(true);
        setShowCndDetails(false);
        setInvalidCid("Please Try Again after sometime");
        console.log("fetch Cnd Details Error", err);
      });
  }

  const getValidEventId = (): string => {
    const EI = sessionStorage.getItem("EI");
    if (!EI) throw new Error("EI not found in sessionStorage");
    const storedData = sessionStorage.getItem("eventData");
    if (storedData) {
      const { event_id, created_at } = JSON.parse(storedData);
      const now = Date.now();
      if (now - created_at < 3600000) {
        return event_id;
      }
    }
    const newEventId = `${EI}_${Date.now()}`;
    const newData = {
      event_id: newEventId,
      created_at: Date.now(),
    };
    sessionStorage.setItem("eventData", JSON.stringify(newData));
    return newEventId;
  };

  function generateFeedback() {
    setClickedGenFeed(true);
    if (eiNotes != "" && !showErrorEi) {
      // setGenText("Regenerate Feedback")
      // setColapseEINotes(true);
      // setShowGenFeedback(true)
      // setShowForm(true)
      // setIntType("Skills Interview")
      // setShowReview(false);
      // setShowNew(false);
      // setSubmitSuccess(false);
      setUserFeedback(eiNotes);
      let inMeetingService = new InMeetingService();
      const requestPayload = {
        user_query:
          "generate feedback for the candidate based on provided Interviewer notes",
        eid: sessionStorage.getItem("EI"),
        cid: sessionStorage.getItem("Cid"),
        session_id: "sess123",
        requisition_id: cndDeatils?.job_Requisition_ID,
        ei_notes: eiNotes,
        wid: "",
        questionnaire_id: "",
        questions: [],
        overall_rating: "",
        overall_comments: "",
        event_id: getValidEventId(),
      };
      setShowLoader(true);
      inMeetingService
        .feedbackGenerateSubmit(requestPayload)
        .then((data: any) => {
          setShowLoader(false);
          let result = data.replaceAll("data: ", "");
          const skillFeedbackStart =
            result.indexOf("Skill Feedback:") + "Skill Feedback:".length;
          const overallFeedbackStart =
            result.indexOf("Overall Feedback:") + "Overall Feedback:".length;
          let skillFeedback = result
            .slice(
              skillFeedbackStart,
              overallFeedbackStart - "Overall Feedback:".length
            )
            .trim();
          let overallFeedback = result.slice(overallFeedbackStart).trim();

          skillFeedback = skillFeedback.length > 0 ? skillFeedback : "";
          overallFeedback = overallFeedback.length > 0 ? overallFeedback : "";
          setSkillReqErr(skillFeedback == "");
          setOverallTextErr(overallFeedback == "");
          setOverallTextQErr(overallFeedback == "");
          if (skillFeedback != undefined && overallFeedback != undefined) {
            setSkillReq(skillFeedback);
            setOverallText(overallFeedback);
            setGenFeedback(overallFeedback);
            setOverallTextQ(overallFeedback);
            setShowForm(true);
            setIntType("Skills Interview");
            setShowReview(false);
            setShowNew(false);
            setSubmitSuccess(false);
            setShowGenFeedback(true);
            setColapseEINotes(true);
            setAiGenComment(true);
            if (genText == "Regenerate Feedback Summary") {
              setGenFeedbackModUsed(false);
              setOwnFeedbackModUsed(false);
              setOwnFeedbackUsed(false);
              setFeedbackType("");
            }
            setGenText("Regenerate Feedback Summary");
            setGenFeedbackUsed(true);
          }
        })
        .catch((err: any) => {
          setShowLoader(false);
          setSkillReqErr(true);
          setOverallTextErr(true);
          setOverallTextQErr(true);
          setShowForm(true);
          setIntType("Skills Interview");
          setShowReview(false);
          setShowNew(false);
          setSubmitSuccess(false);
          setShowGenFeedback(true);
          setColapseEINotes(true);
          setAiGenComment(true);
          if (genText == "Regenerate Feedback Summary") {
            setGenFeedbackModUsed(false);
            setOwnFeedbackModUsed(false);
            setOwnFeedbackUsed(false);
            setFeedbackType("");
          }
          setGenText("Regenerate Feedback Summary");
          setGenFeedbackUsed(true);
          console.log("Generate feedback Error", err);
        });
    }
  }

  function proceedToFeedback() {
    setColapseCndDetails(true);
    setShowReview(false);
    setShowForm(false);
    setShowNew(false);
    setSubmitSuccess(false);
    setShowGenFeedback(true);
  }

  function submitFeedback() {
    setAllowSubmit(false);
    // setSubmitMsg("Interview Feedback submitted successfully")
    // setSubmitSuccess(true);
    // setShowForm(false);
    // setShowNew(false);
    // setShowCndDetails(false);
    // setShowGenFeedback(false);
    // setShowProceedFeed(false);
    let inMeetingService = new InMeetingService();
    let question: any[] = [];
    if (intType == "Skills Interview") {
      // question.push(
      //     {questionid: 'QUESTION_SETUP-6-146', answerid: selectedPrimary == 'Yes'?'QUESTION_MULTIPLE_CHOICE_ANSWER-6-327':'QUESTION_MULTIPLE_CHOICE_ANSWER-6-328'},
      //     {questionid: 'QUESTION_SETUP-6-86', answerid: skillReqText},
      //     {questionid: 'QUESTION_SETUP-6-73', answerid: careerLevelSelected == '1'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-324': careerLevelSelected == '2'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-323' : careerLevelSelected == '3'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-322' : careerLevelSelected == '4'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-321' :
      //         careerLevelSelected == '5'?  'QUESTION_MULTIPLE_CHOICE_ANSWER-6-320' : careerLevelSelected == '6'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-319' : careerLevelSelected == '7'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-318' : careerLevelSelected == '8'?'QUESTION_MULTIPLE_CHOICE_ANSWER-6-317' : careerLevelSelected == '9'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-316' :
      //         careerLevelSelected == '10'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-315' : careerLevelSelected == '11'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-314' : careerLevelSelected == '12'? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-313': careerLevelSelected == '13'?'QUESTION_MULTIPLE_CHOICE_ANSWER-6-312':'QUESTION_MULTIPLE_CHOICE_ANSWER-6-311'
      //     },
      //     {questionid: 'QUESTION_SETUP-3-3297', answerid: selectedOption1 == 'Yes' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-3-3850': 'QUESTION_MULTIPLE_CHOICE_ANSWER-3-3851'},
      //     {questionid: 'QUESTION_SETUP-6-5902', answerid: selectedOption4 == 'Yes' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-6033' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-6034'},
      // )
      // if(selectedOption1 == 'Yes') question.push({questionid: 'QUESTION_SETUP-3-3296', answerid: selectedOption2 == 'Yes' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-3-3848' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-3-3849'})
      // if(selectedOption2 == 'Yes' && selectedOption1 == 'Yes'){
      //     question.push({questionid: 'QUESTION_SETUP-3-3306', answerid: selectedOption3 == 'Yes' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-3-3858' : selectedOption3 == 'No' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-3-3859' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-3-3860'},{questionid: 'QUESTION_SETUP-6-186', answerid: overallTextQ})
      // }
      // if(careerLevelSelected != 'Do Not Recommend'){
      //     question.push({questionid: 'QUESTION_SETUP-6-83', answerid: selectedMonthAtLeval == '48' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-185' : selectedMonthAtLeval == '42' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-184' : selectedMonthAtLeval == '36' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-183' : selectedMonthAtLeval == '30' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-182' : selectedMonthAtLeval == '24' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-181' :
      //         selectedMonthAtLeval == '18' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-180' : selectedMonthAtLeval == '12' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-179' : selectedMonthAtLeval == '6' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-178' : selectedMonthAtLeval == '0' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-177' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-156'
      //     })
      // }
      // if(careerLevelSelected == '6') question.push({questionid: 'QUESTION_SETUP-6-114', answerid: selectedProgPoints == 'E' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-214' : selectedProgPoints == 'D' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-213' : selectedProgPoints == 'C' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-212' : selectedProgPoints == 'B' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-211' : selectedProgPoints == 'A' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-210' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-209' })
      // else if(careerLevelSelected == '7') question.push({questionid: 'QUESTION_SETUP-6-92', answerid: selectedProgPoints == 'D' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-215' : selectedProgPoints == 'C' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-220' : selectedProgPoints == 'B' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-219' : selectedProgPoints == 'A' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-218' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-217'})
      // else if(careerLevelSelected == '9') question.push({questionid: 'QUESTION_SETUP-6-93', answerid: selectedProgPoints == 'D' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-225' : selectedProgPoints == 'C' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-224' : selectedProgPoints == 'B' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-223' : selectedProgPoints == 'A' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-222' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-221'})
      // else if(careerLevelSelected == '10') question.push({questionid: 'QUESTION_SETUP-6-94', answerid: selectedProgPoints == 'B' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-228' : selectedProgPoints == 'A' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-227' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-226'})
      // else if(careerLevelSelected == '11') question.push({questionid: 'QUESTION_SETUP-6-95', answerid: selectedProgPoints == 'A' ? 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-230' : 'QUESTION_MULTIPLE_CHOICE_ANSWER-6-229'})
      question.push(
        {
          questionid: "QUESTION_SETUP-6-11940",
          answerid:
            careerLevelSelected == "1"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11247"
              : careerLevelSelected == "2"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11246"
              : careerLevelSelected == "3"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11245"
              : careerLevelSelected == "4"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11244"
              : careerLevelSelected == "5"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11243"
              : careerLevelSelected == "6"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11242"
              : careerLevelSelected == "7"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11241"
              : careerLevelSelected == "8"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11240"
              : careerLevelSelected == "9"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11239"
              : careerLevelSelected == "10"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11238"
              : careerLevelSelected == "11"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11237"
              : careerLevelSelected == "12"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11236"
              : careerLevelSelected == "13"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11235"
              : careerLevelSelected == "Do Not Recommend"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11194"
              : "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11193",
        },
        {
          questionid: "QUESTION_SETUP-6-12203",
          answerid:
            selectedMonthAtLeval == "36"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11383"
              : selectedMonthAtLeval == "30"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11382"
              : selectedMonthAtLeval == "24"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11381"
              : selectedMonthAtLeval == "18"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11380"
              : selectedMonthAtLeval == "12"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11379"
              : selectedMonthAtLeval == "6"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11378"
              : selectedMonthAtLeval == "0"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11307"
              : "QUESTION_MULTIPLE_CHOICE_ANSWER-6-11312",
        },
        {
          questionid: "QUESTION_SETUP-6-11528",
          answerid:
            selectedOption1 == "Yes"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-6-10933"
              : "QUESTION_MULTIPLE_CHOICE_ANSWER-6-10934",
        }
      );
      if (selectedOption1 == "Yes")
        question.push({
          questionid: "QUESTION_SETUP-3-3296",
          answerid:
            selectedOption2 == "Yes"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-3-3848"
              : "QUESTION_MULTIPLE_CHOICE_ANSWER-3-3849",
        });
      if (selectedOption2 == "Yes" && selectedOption1 == "Yes") {
        question.push({
          questionid: "QUESTION_SETUP-3-3306",
          answerid:
            selectedOption3 == "Yes"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-3-3858"
              : selectedOption3 == "No"
              ? "QUESTION_MULTIPLE_CHOICE_ANSWER-3-3859"
              : "QUESTION_MULTIPLE_CHOICE_ANSWER-3-3860",
        });
      }
      if (
        (selectedOption2 === "Yes" &&
          selectedOption1 === "Yes" &&
          selectedOption3 != "") ||
        (selectedOption2 == "No" && selectedOption1 === "Yes")
      ) {
        question.push({
          questionid: "QUESTION_SETUP-6-186",
          answerid: skillReqText,
        });
      }
      if (overallTextOptional != "") {
        question.push({
          questionid: "QUESTION_SETUP-6-11529",
          answerid: overallTextOptional,
        });
      }
      if (file?.name) {
        question.push({
          questionid: "QUESTION_SETUP-6-11527",
          answerid: base64File,
        });
      }
    }
    const timezoneOffset =
      new Date().toString().match(/\(([^)]+)\)/)?.[1] || "Unknown Timezone";
    const used = new Set<string>();
    const gen7Digit = (): string => {
      let n;
      do n = String(Math.floor(1e6 + Math.random() * 9e6));
      while (used.has(n));
      used.add(n);
      return n;
    };
    const requestPayload = {
      user_query: "Submit the Feedback to workday",
      eid: sessionStorage.getItem("EI"),
      cid: cid,
      session_id: "sess123",
      requisition_id: cndDeatils?.job_Requisition_ID,
      ei_notes: "",
      wid: cndDeatils?.interview_Event_WID,
      Answer_Attachment_id: gen7Digit(),
      uploaded_document_name: file != null ? file?.name : "",
      questionnaire_id: "GLOBAL_QUESTIONNAIRE-6-5105",
      questions: question,
      overall_rating: overallRating,
      overall_comments: overallText,
      event_id: getValidEventId(),
    };
    const submitFeedbackPaylaod = {
      candidateId: cndDeatils.candidate_ID,
      startDate:
        props.MeetingDetails.startTime ||
        sessionStorage.getItem("IntStartDate"),
      endDate:
        props.MeetingDetails.endTime || sessionStorage.getItem("IntEndDate"),
      timeZone: timezoneOffset,
    };
    setShowLoader(true);
    inMeetingService
      .feedbackGenerateSubmit(requestPayload)
      .then((response: any) => {
        // const parsedResponse = JSON.parse(result);
        if (response) {
          let result = response.replaceAll("data: ", "");
          if (
            result.toLowerCase().indexOf("feedback submitted successfully") > -1
          ) {
            inMeetingService
              .SubmitFeedback(submitFeedbackPaylaod)
              .then((response: any) => {
                if (response.status === "Success") {
                  setSubmitMsg(result);
                  setShowRatingTab(true);
                  setSubmitSuccess(true);
                  setShowForm(false);
                  setShowNew(false);
                  setShowCndDetails(false);
                  setShowGenFeedback(false);
                  setShowProceedFeed(false);
                }
              })
              .catch((err: any) => {
                setAllowSubmit(true);
                setShowLoader(false);
                console.log("Submit Feedback Error", err);
              });
          } else {
            setAllowSubmit(true);
            showToast(result, "error");
            setShowRatingTab(false);
          }
          copilotAcceptanceMatrixTrack();
        }
      })
      .catch((err: any) => {
        setAllowSubmit(true);
        setShowLoader(false);
        console.log("Submit Feedback Error", err);
      });
  }

  function checkFeedbackValidations() {
    // if(intType == "Skills Interview"){
    //     if(overallRating != ""  && selectedPrimary != "" && careerLevelSelected != "" && skillReqText != "" &&
    //     selectedOption1 != "" && selectedOption4 != "" && overallText != ""){
    //         if((careerLevelSelected == "Do Not Recommend" && selectedMonthAtLeval == "") || ((careerLevelSelected === "6" || careerLevelSelected === "7" || careerLevelSelected === "9" || careerLevelSelected === "10" || careerLevelSelected === "11") && selectedProgPoints != "" && selectedMonthAtLeval != "") ||
    //         ((careerLevelSelected === "1" || careerLevelSelected === "2" || careerLevelSelected === "3" || careerLevelSelected === "4" || careerLevelSelected === "5" || careerLevelSelected === "8" || careerLevelSelected === "12" || careerLevelSelected === "13") && selectedMonthAtLeval !="")){
    //             // (selectedOption1 == "Yes" && selectedOption2 != "") || (selectedOption1 == "No") ? setAllowSubmit(true) : setAllowSubmit(false)
    //             if(selectedOption1 == "No") setAllowSubmit(true)
    //             else if(selectedOption1 == "Yes" && selectedOption2 == "No") setAllowSubmit(true)
    //             else if(selectedOption1 == "Yes" && selectedOption2 == "Yes" && selectedOption3 != "" && overallTextQ != "") setAllowSubmit(true)
    //             else setAllowSubmit(false)
    //         }
    //         else setAllowSubmit(false)
    //     }
    //     else setAllowSubmit(false)
    // }
    if (intType == "Skills Interview") {
      careerLevelSelected != "" &&
      selectedMonthAtLeval != "" &&
      selectedOption1 != "" &&
      overallRating != "" &&
      overallText != ""
        ? setAllowSubmit(true)
        : setAllowSubmit(false);
    }
  }

  function checkQuestionsYesNo() {
    if (selectedOption1 == "No") {
      setSelectedOption2("");
      setSelectedOption3("");
      // setOverallTextQ("")
    }
    if (selectedOption2 == "No") {
      setSelectedOption3("");
      // setOverallTextQ("")
    }
  }

  function setEiNotesFun(value: any) {
    setEiNotes(value);
    // const noSpacesLength = value.replace(/\s/g, '').length;
    const lettersOnly = value.match(/[a-zA-Z]/g);
    lettersOnly && lettersOnly.length >= 100
      ? setShowErrorEi(false)
      : setShowErrorEi(true);
    // noSpacesLength >= 100 ? setShowErrorEi(false) : setShowErrorEi(true)
  }

  function useInterviewerComment() {
    setSkillReq(eiNotes);
    setOverallText(eiNotes);
    setOverallTextQ(eiNotes);
    setSkillReqErr(false);
    setOverallTextErr(false);
    setOverallTextQErr(false);
    setAiGenComment(false);
    setOwnFeedbackUsed(true);
  }

  function submitRating() {
    setShowLoader(true);
    console.log("Rating", feedbackRating);
    console.log("Additional Feedback", additionalFeedback);
    const requestPayload = {
      input_data: {
        Interview_Id: "102",
        Interview_Eid: sessionStorage.getItem("EI"),
        Rating: String(feedbackRating),
        Comments: additionalFeedback,
      },
    };
    let inMeetingService = new InMeetingService();
    inMeetingService
      .copilotBenefitTracking(requestPayload)
      .then((res: any) => {
        setRatingSubmitted(true);
        setShowLoader(false);
      })
      .catch((err: any) => {
        console.log("submitRating_Error", err);
        setRatingSubmitted(false);
        setShowLoader(false);
      });
  }

  function setSkillReqFeedback(value: any) {
    setSkillReq(value);
    if (!ownFeedbackUsed) setGenFeedbackModUsed(true);
    if (ownFeedbackUsed) setOwnFeedbackModUsed(true);
  }

  function setOverallReqFeedback(value: any) {
    setOverallText(value);
    if (!ownFeedbackUsed) setGenFeedbackModUsed(true);
    if (ownFeedbackUsed) setOwnFeedbackModUsed(true);
  }

  function feedbackTypeCheck() {
    if (genFeedbackUsed) setFeedbackType("1");
    if (genFeedbackModUsed) setFeedbackType("2");
    if (ownFeedbackUsed) setFeedbackType("3");
    if (ownFeedbackModUsed) setFeedbackType("4");
  }

  function copilotAcceptanceMatrixTrack() {
    setShowLoader(true);
    const requestPayload = {
      input_data: {
        Interview_Id: "101",
        User_Feedback: userFeedback,
        Generated_Feedback: genFeedback,
        Submitted_Feedback: skillReqText,
        Feedback_Submit_Type: feedbackType,
      },
    };
    let inMeetingService = new InMeetingService();
    inMeetingService
      .copilotAcceptanceMatrix(requestPayload)
      .then((res: any) => {
        console.log("copilotAcceptanceMatrixTrack", res);
        setShowLoader(false);
      })
      .catch((err) => {
        console.log("copilotAcceptanceMatrixTrack", err);
        setShowLoader(false);
      });
  }

  const showToast = (
    message: string,
    type: "success" | "error" | "info" = "info"
  ) => {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      pauseOnHover: false,
      draggable: false,
      type,
    });
  };

  const handleFileChange = (event: any) => {
    console.log("****file", event.target.files);
    const types = ["docx", "doc", "pdf", "txt"];
    const file = event.target.files[0];
    if (!file) return;
    if (file.size > 5242880) {
      showToast("Please upload files smaller than 5 MB!", "error");
      handleFileRemove();
      return;
    }
    if (
      event.target.files[0] &&
      !types.includes(event.target.files[0].name.split(".").pop().toLowerCase())
    ) {
      showToast(
        "The file format is not supported. Please upload only .docx, .doc, .txt, .pdf type files",
        "error"
      );
      handleFileRemove();
      return;
    }
    setFile(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setBase64File(reader.result as string); // full base64 string including metadata prefix
      console.log("base64", base64File);
    };
  };

  function handleFileRemove() {
    setFile(null);
    setBase64File("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }

  return (
    <div style={{ minWidth: "16rem" }}>
      <div>
        <div className="inmeeting-container">
          <div>
            <div
              className={
                currentTheme == "dark"
                  ? "main-div-dark"
                  : currentTheme == "contrast"
                  ? "main-div-contrast"
                  : "main-div-light"
              }
              style={{ padding: "0.5rem" }}
            >
              {showLoader && (
                <div
                  style={{
                    position: "sticky",
                    justifyContent: "center",
                    verticalAlign: "middle",
                    zIndex: "1000",
                  }}
                >
                  <img className="loader" src="/assets/loader.gif"></img>
                </div>
              )}
              {error && <div>{error}</div>}
              {showNoCnd && <div>{invalidCid}</div>}
              {submitSuccess && (
                <div>
                  <div style={{ justifyContent: "center", display: "flex" }}>
                    {submitMsg}
                  </div>
                  {showRatingTab && (
                    <div>
                      <div
                        style={{ justifyContent: "center", display: "flex" }}
                      >
                        <img
                          className={
                            currentTheme == "dark"
                              ? "check-dark"
                              : currentTheme == "contrast"
                              ? "check-dark"
                              : "check"
                          }
                          style={{ height: "50px" }}
                          src="/assets/check.png"
                        ></img>
                      </div>
                      <div
                        style={{ justifyContent: "center", display: "grid" }}
                      >
                        <div style={{ height: "40px" }}>
                          {[1, 2, 3, 4, 5].map((star) => {
                            return (
                              <span
                                className="start"
                                style={{
                                  cursor: !ratingSubmitted
                                    ? "pointer"
                                    : "not-allowed",
                                  color:
                                    feedbackRating >= star ? "gold" : "gray",
                                  fontSize: `35px`,
                                }}
                                key={star}
                                onClick={() => {
                                  !ratingSubmitted
                                    ? setFeedbackRating(star)
                                    : null;
                                }}
                              >
                                {" "}
                                ★{" "}
                              </span>
                            );
                          })}
                        </div>
                        <div style={{ fontSize: "14px", fontWeight: "600" }}>
                          Additional Comments
                        </div>
                        <div>
                          <textarea
                            className={
                              currentTheme == "dark"
                                ? "text-field-dark"
                                : currentTheme == "contrast"
                                ? "text-field-contrast"
                                : "text-field-light"
                            }
                            style={{
                              height: "3rem",
                              width: "100%",
                              margin: "10px",
                            }}
                            disabled={ratingSubmitted}
                            value={additionalFeedback}
                            onChange={(e) =>
                              setAdditionalFeedback(e.target.value)
                            }
                          ></textarea>
                        </div>
                        <Button
                          className={
                            currentTheme == "contrast"
                              ? "button-contrast"
                              : "button-light"
                          }
                          disabled={ratingSubmitted}
                          onClick={() => submitRating()}
                          style={{
                            padding: "10px",
                            borderRadius: "4px",
                            margin: "0 0.5rem",
                            height: "30px",
                            fontSize: "12px",
                          }}
                        >
                          Rate Us
                        </Button>
                      </div>
                    </div>
                  )}
                  {props.MeetingDetails?.meetingId == undefined && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        margin: "1.5rem 0 1rem 0",
                        gap: "0.5rem",
                        cursor: "pointer",
                      }}
                      onClick={() => reset()}
                    >
                      <div style={{ fontSize: "14px", fontWeight: "600" }}>
                        Proceed For New Candidate
                      </div>
                      <div>
                        <img
                          className={
                            currentTheme == "dark"
                              ? "check-dark"
                              : currentTheme == "contrast"
                              ? "check-dark"
                              : "check"
                          }
                          style={{ height: "20px" }}
                          src="/assets/next.png"
                        ></img>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {showNew && (
                <div>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "1rem",
                      paddingBottom: "1rem",
                    }}
                  >
                    <div
                      className={
                        currentTheme == "contrast"
                          ? "heading-contrast"
                          : "heading-light"
                      }
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Interview Feedback
                    </div>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      width: "100%",
                      alignItems: "center",
                      textAlign: "center",
                      placeItems: "center",
                    }}
                  >
                    <label>Candidate Id:</label>
                    <input
                      type="text"
                      className={
                        currentTheme == "dark"
                          ? "text-field-dark"
                          : currentTheme == "contrast"
                          ? "text-field-contrast"
                          : "text-field-light"
                      }
                      style={{ height: "30px", margin: "0.5rem 0" }}
                      value={cid}
                      onChange={(e) => setCid(e.target.value)}
                    ></input>
                  </div>
                  <div
                    style={{
                      padding: "0.5rem",
                      justifyContent: "center",
                      display: "grid",
                    }}
                  >
                    <Button
                      className={
                        currentTheme == "contrast"
                          ? "button-contrast"
                          : "button-light"
                      }
                      disabled={cid == ""}
                      onClick={() => fetchCandidateDetails()}
                      style={{
                        padding: "10px",
                        borderRadius: "4px",
                        margin: "0 0.5rem",
                        height: "30px",
                        fontSize: "12px",
                      }}
                    >
                      Fetch Details
                    </Button>
                    {invalidCid != "" && (
                      <div style={{ fontSize: "12px", color: "red" }}>
                        {invalidCid}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {showCndDetails && (
                <div className="candidatedetailsDiv">
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      paddingBottom: "1rem",
                    }}
                  >
                    {!colapseCndDetails && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => setColapseCndDetails(true)}
                      >
                        <img
                          className={
                            currentTheme == "dark"
                              ? "check-dark"
                              : currentTheme == "contrast"
                              ? "check-dark"
                              : "check"
                          }
                          style={{ height: "15px" }}
                          src="/assets/down-arrow.png"
                        ></img>
                      </div>
                    )}
                    {colapseCndDetails && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => setColapseCndDetails(false)}
                      >
                        <img
                          className={
                            currentTheme == "dark"
                              ? "check-dark"
                              : currentTheme == "contrast"
                              ? "check-dark"
                              : "check"
                          }
                          style={{ height: "15px" }}
                          src="/assets/right-arrow.png"
                        ></img>
                      </div>
                    )}
                    <div
                      className={
                        currentTheme == "contrast"
                          ? "heading-contrast"
                          : "heading-light"
                      }
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Candidate Details
                    </div>
                  </div>
                  {!colapseCndDetails && (
                    <div>
                      <div className="row first-row value-txt-cndname">
                        <div className="col-md-12">
                          <label>
                            <span style={{ fontWeight: "600" }}>Name:</span>
                            {" " +
                              cndDeatils?.legal_First_Name +
                              " " +
                              cndDeatils?.legal_Last_Name}
                          </label>
                        </div>
                      </div>
                      <div className="row second-row value-txt">
                        <div className="col-md-12">
                          <label>
                            <span style={{ fontWeight: "600" }}>
                              Candidate ID:
                            </span>
                            {" " + cndDeatils?.candidate_ID}
                          </label>
                        </div>
                      </div>
                      <div className="row third-row value-txt">
                        <div className="col-md-12">
                          <label>
                            <span style={{ fontWeight: "600" }}>Level:</span>
                            {" " + cndDeatils?.management_Level}{" "}
                          </label>
                        </div>
                      </div>
                      <div className="row fourth-row value-txt">
                        <div className="col-md-12">
                          <label>
                            <span style={{ fontWeight: "600" }}>
                              Location:{" "}
                            </span>
                            {cndDeatils?.candidate_Location || "NA"}
                          </label>
                        </div>
                      </div>
                      <div className="row fourth-row value-txt">
                        <div className="col-md-12">
                          <label>
                            <span style={{ fontWeight: "600" }}>
                              Interview Type:
                            </span>
                            {" " + cndDeatils?.interviewType}
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  {!showGenFeedback && showProceedFeed && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        margin: "1.5rem 0 1rem 0",
                        gap: "0.5rem",
                        cursor: "pointer",
                      }}
                      onClick={() => proceedToFeedback()}
                    >
                      {/* <Button className={(currentTheme == 'contrast'?'button-contrast' : 'button-light')} onClick={() => proceedToFeedback()} style={{padding: "10px", borderRadius: "4px", margin: "0 0.5rem", height: "30px", fontSize: "12px" } }>Proceed to Feedback</Button> */}
                      <div style={{ fontSize: "14px", fontWeight: "600" }}>
                        Proceed to Submit Feedback
                      </div>
                      <div>
                        <img
                          className={
                            currentTheme == "dark"
                              ? "check-dark"
                              : currentTheme == "contrast"
                              ? "check-dark"
                              : "check"
                          }
                          style={{ height: "20px" }}
                          src="/assets/next.png"
                        ></img>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {showGenFeedback && (
                <div>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    {!colapseEINotes && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => setColapseEINotes(true)}
                      >
                        <img
                          className={
                            currentTheme == "dark"
                              ? "check-dark"
                              : currentTheme == "contrast"
                              ? "check-dark"
                              : "check"
                          }
                          style={{ height: "15px" }}
                          src="/assets/down-arrow.png"
                        ></img>
                      </div>
                    )}
                    {colapseEINotes && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => setColapseEINotes(false)}
                      >
                        <img
                          className={
                            currentTheme == "dark"
                              ? "check-dark"
                              : currentTheme == "contrast"
                              ? "check-dark"
                              : "check"
                          }
                          style={{ height: "15px" }}
                          src="/assets/right-arrow.png"
                        ></img>
                      </div>
                    )}
                    <div
                      className={
                        currentTheme == "contrast"
                          ? "heading-contrast"
                          : "heading-light"
                      }
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Interviewer Notes
                    </div>
                  </div>
                  {!colapseEINotes && (
                    <div>
                      <div
                        style={{ paddingTop: "0.5rem", width: "max-content" }}
                      >
                        <TooltipHost
                          content={tooltipContent}
                          id="tooltip-1"
                          directionalHint={DirectionalHint.leftCenter}
                        >
                          <div style={{ display: "flex", gap: "0.5rem" }}>
                            <div
                              style={{ fontSize: "13px", fontWeight: "600" }}
                            >
                              Interview Feedback Guidelines
                            </div>
                            <div>
                              <img
                                className={
                                  currentTheme == "dark"
                                    ? "check-dark"
                                    : currentTheme == "contrast"
                                    ? "check-dark"
                                    : "check"
                                }
                                style={{ height: "20px" }}
                                src="/assets/overview.png"
                              ></img>
                            </div>
                          </div>
                        </TooltipHost>
                      </div>
                      <div style={{ padding: "0.5rem 0" }}>
                        <div
                          style={{ paddingBottom: "0.5rem", fontSize: "14px" }}
                        >
                          <label>Enter Interviewer Notes: (Required)</label>
                        </div>
                        <div>
                          <textarea
                            className={
                              currentTheme == "dark"
                                ? "text-field-dark"
                                : currentTheme == "contrast"
                                ? "text-field-contrast"
                                : "text-field-light"
                            }
                            style={{ height: "7rem", width: "100%" }}
                            value={eiNotes}
                            onChange={(e) => setEiNotesFun(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gap: "5px",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          className={
                            currentTheme == "contrast"
                              ? "button-contrast"
                              : "button-light"
                          }
                          onClick={() => generateFeedback()}
                          style={{
                            padding: "10px",
                            borderRadius: "4px",
                            margin: "0 0.5rem",
                            height: "30px",
                            fontSize: "12px",
                          }}
                        >
                          {genText}
                        </Button>
                        {showErrorEi && clickedGenFeed && (
                          <div style={{ fontSize: "12px", color: "red" }}>
                            Please enter meaningful Interviewer Notes of minimum
                            100 character or more.
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {showForm && (
                <div>
                  {intType == "Skills Interview" && (
                    <div style={{ marginTop: "1rem" }}>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        {!colapseSkillsForm && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => setColapseSkillsForm(true)}
                          >
                            <img
                              className={
                                currentTheme == "dark"
                                  ? "check-dark"
                                  : currentTheme == "contrast"
                                  ? "check-dark"
                                  : "check"
                              }
                              style={{ height: "15px" }}
                              src="/assets/down-arrow.png"
                            ></img>
                          </div>
                        )}
                        {colapseSkillsForm && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => setColapseSkillsForm(false)}
                          >
                            <img
                              className={
                                currentTheme == "dark"
                                  ? "check-dark"
                                  : currentTheme == "contrast"
                                  ? "check-dark"
                                  : "check"
                              }
                              style={{ height: "15px" }}
                              src="/assets/right-arrow.png"
                            ></img>
                          </div>
                        )}
                        <div
                          className={
                            currentTheme == "contrast"
                              ? "heading-contrast"
                              : "heading-light"
                          }
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Detailed Feedback
                        </div>
                      </div>
                      {!colapseSkillsForm && (
                        <div>
                          {!readMore && (
                            <div style={{ padding: "10px 0 0 0" }}>
                              <div
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "600",
                                  fontStyle: "italic",
                                }}
                              >
                                Before submitting this feedback, you must review
                                and edit the Final Feedback text (as necessary)
                                to ensure that the words and sentiment are your
                                own.{" "}
                                <span
                                  style={{ color: "blue", cursor: "pointer" }}
                                  onClick={() => setReadMore(true)}
                                >
                                  Read More...
                                </span>
                              </div>
                            </div>
                          )}
                          {readMore && (
                            <div>
                              <div style={{ padding: "10px 0 0 0" }}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    fontStyle: "italic",
                                  }}
                                >
                                  Before submitting this feedback, you must
                                  review and edit the Final Feedback text (as
                                  necessary) to ensure that the words and
                                  sentiment are your own. You are fully
                                  responsible for the feedback submitted from
                                  this form. Once submitted, your feedback
                                  cannot be edited.
                                </div>
                              </div>
                              <div
                                style={{
                                  padding: "0.5rem 0",
                                  display: "grid",
                                  fontSize: "12px",
                                }}
                              >
                                <p>
                                  Please provide a detailed summary providing
                                  relevant information supporting why you are or
                                  are not recommending this candidate
                                  {/* Please provide your detailed assessment of the
                                  candidate's proficiency based on the required
                                  skills. */}
                                </p>
                                {/* <p>
                                  If you want to move forward with this
                                  applicant, please provide the relavent
                                  recommendation for career level, progression
                                  point, and/or months at level.
                                </p>
                                <p>
                                  If you do not want to move forward with this
                                  applicant, please indicate 'Do Not Recommend'
                                  in the career level field and 'Not Applicant'
                                  in the subsequent fields.
                                </p> */}
                              </div>
                            </div>
                          )}
                          <div
                            className={
                              currentTheme == "dark"
                                ? "questions-div-dark"
                                : currentTheme == "contrast"
                                ? "questions-div-contrast"
                                : "questions-div-light"
                            }
                            style={{ padding: "0.5rem" }}
                          >
                            {/* <div style={{ padding: "0.5rem", borderBottom: "1.5px solid lightgray" }}>
                                                            <div style={{ paddingBottom: "0.5rem",fontSize:"12px" }}><label>Are you the Primary Interviewer or capturing on behalf of the Primary Interviewer (Required)</label></div>
                                                            <div style={{ display: "grid", gap: "0.5rem", fontSize:"12px"}}>
                                                                <label><input style={{ marginRight: "0.5rem" }} value="Yes" type="radio" checked={selectedPrimary === "Yes"} onChange={e => setSelectedPrimary(e.target.value)}></input>I am the Primary Interviewer</label>
                                                                <label><input style={{ marginRight: "0.5rem" }} type="radio" value="No" checked={selectedPrimary === "No"} onChange={e => setSelectedPrimary(e.target.value)}></input>I am capturing on behalf of the Primary Interviewer</label>
                                                            </div>
                                                        </div> */}
                            {/* <div style={{ padding: "0.5rem", borderBottom: "1.5px solid lightgray" }}>
                                                            <div style={{ paddingBottom: "0.5rem", fontSize:"12px"}}>
                                                                <label>Does the candidate meet the skills requirements for the role? Please elaborate: (Required)</label>
                                                            </div>
                                                            <div><textarea className={(currentTheme == 'dark'?'text-field-dark' : currentTheme == 'contrast'?'text-field-contrast' : 'text-field-light')} style={{ height: "3rem", width: "100%" }} value={skillReqText} onChange={e => setSkillReqFeedback(e.target.value)}></textarea></div>
                                                            {aiGenComment &&<div><p style={{color:"red", fontSize :"11px", margin:"0"}}>This text is generated from Agentic AI, please review it before Submitting</p></div>}
                                                            {skillReqErr && <div><p style={{color:"red", fontSize :"11px", margin:"0"}}>Oops! Something went wrong.</p></div>}
                                                        </div> */}
                            {/* <div style={{ display:"grid", gap:"5px", justifyContent:"center", marginTop:"1rem" }}>
                                                            <Button className={(currentTheme == 'contrast'?'button-contrast' : 'button-light')} onClick={() => useInterviewerComment()} style={{padding: "10px", borderRadius: "4px", margin: "0 0.5rem", height: "30px", fontSize: "12px" } }>Use My Feedback</Button>
                                                        </div> */}
                            <div
                              style={{
                                padding: "0.5rem",
                                borderBottom: "1.5px solid lightgray",
                              }}
                            >
                              <div
                                style={{
                                  paddingBottom: "0.5rem",
                                  fontSize: "12px",
                                }}
                              >
                                <label>
                                  Offline Interview Feedback Form (For all
                                  countries using offline feedback forms you
                                  MUST attach it here. For those who are not
                                  please ensure a full summary is provided in
                                  the text boxes below.)
                                  <em>(Optional)</em>
                                </label>
                              </div>
                              <div
                                className="col-md-12"
                                style={{ width: "100%" }}
                              >
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  onChange={handleFileChange}
                                  accept=".pdf,.doc,.docx,.txt"
                                />
                                {file?.name && (
                                  <button onClick={handleFileRemove}>
                                    Remove File
                                  </button>
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                padding: "0.5rem",
                                borderBottom: "1.5px solid lightgray",
                              }}
                            >
                              <div
                                style={{
                                  paddingBottom: "0.5rem",
                                  fontSize: "12px",
                                }}
                              >
                                <label>
                                  Please provide recommendation for Management
                                  Level (Required)
                                </label>
                              </div>
                              <div
                                className="col-md-12"
                                style={{ width: "100%" }}
                              >
                                <Dropdown
                                  onOptionSelect={onCareerLevelChanged}
                                  placeholder="select one"
                                  style={{ minWidth: "12rem" }}
                                >
                                  {careerLevel.map((option: any) => (
                                    <Option key={option.id} value={option.id}>
                                      {option.value}
                                    </Option>
                                  ))}
                                </Dropdown>
                              </div>
                            </div>
                            {/* {
                                                            (careerLevelSelected === "6" || careerLevelSelected === "7" || careerLevelSelected === "9" || careerLevelSelected === "10" || careerLevelSelected === "11") &&
                                                            <div style={{ padding: "0.5rem", borderBottom: "1.5px solid lightgray" }}>
                                                                <div style={{ paddingBottom: "0.5rem", fontSize:"12px" }}><label>Please select the recommended Progression Point (S&C Only): (Required)</label></div>
                                                                <div>
                                                                    {progressionPoints.map((point) => (
                                                                        <div>
                                                                            {
                                                                                point.level == careerLevelSelected && 
                                                                                <div style={{ display: "grid", gap: "0.5rem", padding: "0 0.5rem", fontSize:"12px"}}>
                                                                                    {point.array.map((data) =>(
                                                                                        <label><input style={{ marginRight: "0.5rem" }} value={data.id} type="radio" checked={selectedProgPoints === data.id} onChange={e => setSelectedProgPoints(e.target.value)}></input>{data.value}</label>
                                                                                    ))}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            ((careerLevelSelected === "1" || careerLevelSelected === "2" || careerLevelSelected === "3" || careerLevelSelected === "4" || careerLevelSelected === "5" || careerLevelSelected === "8" || careerLevelSelected === "12" || careerLevelSelected === "13") || 
                                                            ((careerLevelSelected === "6" || careerLevelSelected === "7" || careerLevelSelected === "9" || careerLevelSelected === "10" || careerLevelSelected === "11") && selectedProgPoints != "")) &&
                                                            <div style={{ padding: "0.5rem", borderBottom: "1.5px solid lightgray" }}>
                                                                <div style={{ paddingBottom: "0.5rem", fontSize:"12px" }}><label>Recommended months at level: (Required)</label></div>
                                                                <div style={{ width: "100%" }}>
                                                                    <Dropdown onOptionSelect={onMonthLevelChanged} placeholder="Select "  style={{minWidth:"12rem"}}>
                                                                        {recommendedMonths.map((option: any) => (
                                                                        <Option key={option.id} value={option.id}>
                                                                            {option.value}
                                                                        </Option>
                                                                        ))}
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        } */}
                            <div
                              style={{
                                padding: "0.5rem",
                                borderBottom: "1.5px solid lightgray",
                              }}
                            >
                              <div
                                style={{
                                  paddingBottom: "0.5rem",
                                  fontSize: "12px",
                                }}
                              >
                                <label>
                                  What is the recommended Experienced Hire
                                  Service Credit (EHSC)? (Note: This is only
                                  applicable for{" "}
                                  <strong>
                                    <u>external</u>
                                  </strong>{" "}
                                  candidates. If you did not assess EHSC, or do
                                  not need to assess it for this role, please
                                  select Not Applicable) (Required)
                                </label>
                              </div>
                              <div style={{ width: "100%" }}>
                                <Dropdown
                                  onOptionSelect={onMonthLevelChanged}
                                  placeholder="select one"
                                  style={{ minWidth: "12rem" }}
                                >
                                  {recommendedMonths.map((option: any) => (
                                    <Option key={option.id} value={option.id}>
                                      {option.value}
                                    </Option>
                                  ))}
                                </Dropdown>
                              </div>
                            </div>
                            <div
                              style={{
                                padding: "0.5rem",
                                borderBottom: "1.5px solid lightgray",
                              }}
                            >
                              <div
                                style={{
                                  paddingBottom: "0.5rem",
                                  fontSize: "12px",
                                }}
                              >
                                <label>
                                  Is this interview related to a role for
                                  Software & Platform - Trust & Safety Clients?
                                  If unsure, choose No. (Required)
                                </label>
                              </div>
                              <div style={{ display: "flex", gap: "0.5rem" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    style={{ marginRight: "0.5rem" }}
                                    value="Yes"
                                    type="radio"
                                    checked={selectedOption1 === "Yes"}
                                    onChange={(e) =>
                                      setSelectedOption1(e.target.value)
                                    }
                                  ></input>
                                  Yes
                                </label>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    style={{ marginRight: "0.5rem" }}
                                    type="radio"
                                    value="No"
                                    checked={selectedOption1 === "No"}
                                    onChange={(e) =>
                                      setSelectedOption1(e.target.value)
                                    }
                                  ></input>
                                  No
                                </label>
                              </div>
                            </div>
                            {selectedOption1 === "Yes" && (
                              <div
                                style={{
                                  padding: "0.5rem",
                                  borderBottom: "1.5px solid lightgray",
                                }}
                              >
                                <div
                                  style={{
                                    paddingBottom: "0.5rem",
                                    fontSize: "12px",
                                  }}
                                >
                                  <label>
                                    Has a Resiliency Discussion been completed
                                    with this candidate?
                                  </label>
                                </div>
                                <div style={{ display: "flex", gap: "0.5rem" }}>
                                  <label
                                    style={{
                                      fontSize: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      style={{ marginRight: "0.5rem" }}
                                      value="Yes"
                                      type="radio"
                                      checked={selectedOption2 === "Yes"}
                                      onChange={(e) =>
                                        setSelectedOption2(e.target.value)
                                      }
                                    ></input>
                                    Yes
                                  </label>
                                  <label
                                    style={{
                                      fontSize: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      style={{ marginRight: "0.5rem" }}
                                      type="radio"
                                      value="No"
                                      checked={selectedOption2 === "No"}
                                      onChange={(e) =>
                                        setSelectedOption2(e.target.value)
                                      }
                                    ></input>
                                    No
                                  </label>
                                </div>
                              </div>
                            )}
                            {selectedOption2 === "Yes" &&
                              selectedOption1 === "Yes" && (
                                <div
                                  style={{
                                    padding: "0.5rem",
                                    borderBottom: "1.5px solid lightgray",
                                  }}
                                >
                                  <div
                                    style={{
                                      paddingBottom: "0.5rem",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <label>
                                      Has the candidate confirmed they want to
                                      proceed with the recruitment process?
                                    </label>
                                  </div>
                                  <div
                                    style={{ display: "flex", gap: "0.5rem" }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        style={{ marginRight: "0.5rem" }}
                                        value="Yes"
                                        type="radio"
                                        checked={selectedOption3 === "Yes"}
                                        onChange={(e) =>
                                          setSelectedOption3(e.target.value)
                                        }
                                      ></input>
                                      Yes
                                    </label>
                                    <label
                                      style={{
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        style={{ marginRight: "0.5rem" }}
                                        type="radio"
                                        value="No"
                                        checked={selectedOption3 === "No"}
                                        onChange={(e) =>
                                          setSelectedOption3(e.target.value)
                                        }
                                      ></input>
                                      No
                                    </label>
                                    <label
                                      style={{
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        style={{ marginRight: "0.5rem" }}
                                        type="radio"
                                        value="Undecided"
                                        checked={
                                          selectedOption3 === "Undecided"
                                        }
                                        onChange={(e) =>
                                          setSelectedOption3(e.target.value)
                                        }
                                      ></input>
                                      Undecided
                                    </label>
                                  </div>
                                </div>
                              )}
                            {((selectedOption2 === "Yes" &&
                              selectedOption1 === "Yes" &&
                              selectedOption3 != "") ||
                              (selectedOption2 == "No" &&
                                selectedOption1 === "Yes")) && (
                              // <div style={{ padding: "0.5rem", borderBottom: "1.5px solid lightgray" }}>
                              //     <div style={{ paddingBottom: "0.5rem", fontSize:"12px"}}>
                              //         <label>Overall comments/concerns</label>
                              //     </div>
                              //     <div><textarea className={(currentTheme == 'dark'?'text-field-dark' : currentTheme == 'contrast'?'text-field-contrast' : 'text-field-light')} style={{ height: "3rem", width: "100%" }} value={overallTextQ} onChange={e => setOverallTextQ(e.target.value)}></textarea></div>
                              //     {aiGenComment && <div><p style={{color:"red", fontSize :"11px", margin:"0"}}>This text is generated from Agentic AI, please review it before Submitting</p></div>}
                              //     {overallTextQErr && <div><p style={{color:"red", fontSize :"11px", margin:"0"}}>AI assisted feedback generation failed. You can provide feedback manually or try again!</p></div>}
                              // </div>
                              <div
                                style={{
                                  padding: "0.5rem",
                                  borderBottom: "1.5px solid lightgray",
                                }}
                              >
                                <div
                                  style={{
                                    paddingBottom: "0.5rem",
                                    fontSize: "12px",
                                  }}
                                >
                                  <label>Overall Comments/Concerns</label>
                                </div>
                                <div>
                                  <textarea
                                    className={
                                      currentTheme == "dark"
                                        ? "text-field-dark"
                                        : currentTheme == "contrast"
                                        ? "text-field-contrast"
                                        : "text-field-light"
                                    }
                                    style={{ height: "3rem", width: "100%" }}
                                    value={skillReqText}
                                    onChange={(e) =>
                                      setSkillReqFeedback(e.target.value)
                                    }
                                  ></textarea>
                                </div>
                                {aiGenComment && (
                                  <div>
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "11px",
                                        margin: "0",
                                      }}
                                    >
                                      This text is generated from Agentic AI,
                                      please review it before Submitting
                                    </p>
                                  </div>
                                )}
                                {skillReqErr && (
                                  <div>
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "11px",
                                        margin: "0",
                                      }}
                                    >
                                      AI assisted feedback generation failed.
                                      You can provide feedback manually or try
                                      again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            )}
                            {/* <div style={{ padding: "0.5rem" }}>
                                                            <div style={{ paddingBottom: "0.5rem",fontSize:"12px" }}><label>Please confirm that you are aware of the candidate's work experience, education and have made a recruiting decision based on the factors including this information.</label></div>
                                                            <div style={{ display: "flex", gap: "0.5rem"}}>
                                                                <label style={{fontSize:"12px", display:"flex", alignItems:"center"}}><input style={{ marginRight: "0.5rem" }} value="Yes" type="radio" checked={selectedOption4 === "Yes"} onChange={e => setSelectedOption4(e.target.value)}></input>Yes</label>
                                                                <label style={{fontSize:"12px", display:"flex", alignItems:"center"}}><input style={{ marginRight: "0.5rem" }} type="radio" value="No" checked={selectedOption4 === "No"} onChange={e => setSelectedOption4(e.target.value)}></input>No</label>
                                                            </div>
                                                        </div> */}
                            <div
                              style={{
                                padding: "0.5rem",
                                borderBottom: "1.5px solid lightgray",
                              }}
                            >
                              <div
                                style={{
                                  paddingBottom: "0.5rem",
                                  fontSize: "12px",
                                }}
                              >
                                <label>
                                  Please provide in the
                                  <strong>Overall Comment box</strong>
                                  (below in Overall Feedback Section), a
                                  detailed feedback summary for the Hiring
                                  Manager to review explaining your
                                  recommendation.
                                </label>
                                <br />
                                <label>
                                  If you have any other information that you
                                  feel is relevant, you may put it in this
                                  comment box.<em>(Optional)</em>
                                </label>
                              </div>
                              <div>
                                <textarea
                                  className={
                                    currentTheme == "dark"
                                      ? "text-field-dark"
                                      : currentTheme == "contrast"
                                      ? "text-field-contrast"
                                      : "text-field-light"
                                  }
                                  style={{ height: "3rem", width: "100%" }}
                                  value={overallTextOptional}
                                  onChange={(e) =>
                                    setOverallTextOptional(e.target.value)
                                  }
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div
                    style={{
                      display: "grid",
                      alignItems: "center",
                      paddingTop: "1rem",
                    }}
                  >
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {!colapseOverallForm && (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => setColapseOverallForm(true)}
                        >
                          <img
                            className={
                              currentTheme == "dark"
                                ? "check-dark"
                                : currentTheme == "contrast"
                                ? "check-dark"
                                : "check"
                            }
                            style={{ height: "15px" }}
                            src="/assets/down-arrow.png"
                          ></img>
                        </div>
                      )}
                      {colapseOverallForm && (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => setColapseOverallForm(false)}
                        >
                          <img
                            className={
                              currentTheme == "dark"
                                ? "check-dark"
                                : currentTheme == "contrast"
                                ? "check-dark"
                                : "check"
                            }
                            style={{ height: "15px" }}
                            src="/assets/right-arrow.png"
                          ></img>
                        </div>
                      )}
                      <div
                        className={
                          currentTheme == "contrast"
                            ? "heading-contrast"
                            : "heading-light"
                        }
                        style={{ fontSize: "16px", fontWeight: "600" }}
                      >
                        Overall Feedback
                      </div>
                    </div>
                    {!colapseOverallForm && (
                      <div
                        className={
                          currentTheme == "dark"
                            ? "questions-div-dark"
                            : currentTheme == "contrast"
                            ? "questions-div-contrast"
                            : "questions-div-light"
                        }
                        style={{ padding: "0.5rem" }}
                      >
                        <div
                          style={{
                            padding: "0.5rem",
                            borderBottom: "1.5px solid lightgray",
                          }}
                        >
                          <div
                            style={{
                              paddingBottom: "0.5rem",
                              fontSize: "12px",
                            }}
                          >
                            <label>
                              Overall Rating
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Dropdown
                              onOptionSelect={onOverallRatingChanged}
                              placeholder="select one"
                              style={{ minWidth: "12rem" }}
                              disableAutoFocus={true}
                            >
                              {overallRatingArray.map((option: any) => (
                                <Option key={option.id} value={option.id}>
                                  {option.value}
                                </Option>
                              ))}
                            </Dropdown>
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0.5rem 0.5rem 0 0.5rem",
                            borderBottom: "1.5px solid lightgray",
                          }}
                        >
                          <div
                            style={{
                              paddingBottom: "0.5rem",
                              fontSize: "12px",
                            }}
                          >
                            <label>
                              Overall Comment
                              <span style={{ color: "red" }}>*</span>
                            </label>
                          </div>
                          <div>
                            <textarea
                              className={
                                currentTheme == "dark"
                                  ? "text-field-dark"
                                  : currentTheme == "contrast"
                                  ? "text-field-contrast"
                                  : "text-field-light"
                              }
                              style={{ height: "3rem", width: "100%" }}
                              value={overallText}
                              onChange={(e) =>
                                setOverallReqFeedback(e.target.value)
                              }
                            ></textarea>
                          </div>
                          {aiGenComment && (
                            <div>
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "11px",
                                  margin: "0",
                                }}
                              >
                                This text is generated from Agentic AI, please
                                review it before Submitting
                              </p>
                            </div>
                          )}
                          {overallTextErr && (
                            <div>
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "11px",
                                  margin: "0",
                                }}
                              >
                                AI assisted feedback generation failed. You can
                                provide feedback manually or try again!
                              </p>
                            </div>
                          )}
                          <div
                            style={{
                              display: "grid",
                              gap: "5px",
                              justifyContent: "center",
                              marginTop: "1rem",
                            }}
                          >
                            <Button
                              className={
                                currentTheme == "contrast"
                                  ? "button-contrast"
                                  : "button-light"
                              }
                              onClick={() => useInterviewerComment()}
                              style={{
                                padding: "10px",
                                borderRadius: "4px",
                                margin: "0 0.5rem 0.5rem 0.5rem",
                                height: "30px",
                                fontSize: "12px",
                              }}
                            >
                              Use My Feedback
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "grid",
                        gap: "5px",
                        justifyContent: "center",
                        marginTop: "1rem",
                      }}
                    >
                      <Button
                        className={
                          currentTheme == "contrast"
                            ? "button-contrast"
                            : "button-light"
                        }
                        disabled={!allowSubmit}
                        onClick={() => submitFeedback()}
                        style={{
                          padding: "10px",
                          borderRadius: "4px",
                          margin: "0 0.5rem",
                          height: "30px",
                          fontSize: "12px",
                        }}
                      >
                        Submit Feedback
                      </Button>
                      {submitMsg == "Please try again sometime" && (
                        <div style={{ fontSize: "12px", color: "red" }}>
                          Please try again sometime
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
